import { useEffect, useState } from 'react';
import { getWithdrawableContracts, type WithdrawableContract } from '@/features/subscription/api';

/**
 * §356a (L.3): the user's withdrawable contracts (subs + packages). Drives the
 * per-package "Vertrag widerrufen" buttons and the mask prefill. Returns an
 * empty list when the feature flag is off (backend enforces this) or on error
 * — the button surface simply stays hidden.
 */
export function useWithdrawableContracts(): {
  contracts: WithdrawableContract[];
  loading: boolean;
} {
  const [contracts, setContracts] = useState<WithdrawableContract[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    getWithdrawableContracts()
      .then((c) => {
        if (active) setContracts(c);
      })
      .catch(() => {
        if (active) setContracts([]);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return { contracts, loading };
}
